import Headroom from "headroom.js";

export default class RevealHeaderOnScroll {
  constructor(el) {
    // This class depends on support of `position: sticky` in CSS.
    // If it's not supported, just use a static header instead.
    if (!this.supportsSticky) return;

    this.el = el;
    this.headroom = new Headroom(el, this.headroomOptions);

    this.headroom.init();
  }

  get supportsSticky() {
    try {
      const supports = "CSS" in window && CSS.supports("position", "sticky");
      return supports;
    } catch (error) {
      return false;
    }
  }

  get headroomOptions() {
    return {
      offset: 150,
      classes: {
        // when element is initialised
        initial: "header-is-initial",
        // when scrolling up
        pinned: "header-is-pinned",
        // when scrolling down
        unpinned: "header-is-unpinned",
        // when above offset
        top: "header-is-top",
        // when below offset
        notTop: "header-is-not-top",
        bottom: "header-is-bottom",
        notBottom: "header-is-not-bottom",
        frozen: "header-is-frozen",
      },
    };
  }
}
